// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "-" + {"149":"b08ac11f93adf02f6502","710":"1007aea12dded3f7e394"}[chunkId] + ".js";
};